module.exports = __webpack_public_path__ + "img/Asset10.fdcaa917.png";